export default {

  getRules() {
    return {
        'disclosure_federal_e_sign': { required: true,messages: {required: "You must agree to the electronic disclosure." } },
        'disclosure_marketing': { required: true, messages: { required: "You must agree to the electronic consent." } },
        // 'funding_method': { required: true, messages: { required: "Please select a funding method." } },
    }
  }
}